import React, { PropsWithChildren } from 'react';
import { Box, Text } from '@clariness/clarikit-react';

export const AccountPageLayoutHeading = ({
  children,
}: PropsWithChildren<unknown>) => {
  return (
    <Box style={{ marginBottom: '20px' }}>
      <Text as="h1" variant="headingMd">
        {children}
      </Text>
    </Box>
  );
};
